import "./App.css";

import React, { useEffect } from "react";

import Tracking from "./tracking";
import TrackEntry from "./tracking/TrackEntry";
import TrackingOrderDetail from "./orderStatus/trackingOrderDetail";
import NotFound from "./orderStatus/notFound"

import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import { theme } from "./theme";
import NavigationBar from "./NavigationBar";
import { ThemeProvider } from "@material-ui/core";



function App() {
  require("dotenv").config();
  
  useEffect(() => {  
     
  }, []);


  return (
    <ThemeProvider theme={theme}>
      <React.Fragment>
        <Router>          
          <NavigationBar/>
          <Routes>
            <Route path="/"  element={ <Tracking type="none"/>}> </Route>
            <Route path="/Tracking"  element={ <Tracking type="none"/>}> </Route>
            <Route path="/trackNo/:trackingNumber" element={<TrackingOrderDetail trakingType="trackingNumber"/>}> </Route>
            <Route path="/notFound" element={ <NotFound />}> </Route>
            <Route path="/track" element={<TrackEntry/>}> </Route>
          </Routes>         
        </Router>
      </React.Fragment>
    </ThemeProvider>
  );
}

export default App;

